import HolidayBanner from './HolidayBanner';

export default HolidayBanner;
